import { ConversationMessageDto } from '@endion/types';
import { useCustomerChatbotContext } from '../../hooks/use-customer-chatbot-context';
import { AiMessage } from './ai-message';
import { UserMessage } from './user-message';

type ChatMessageProps = {
  message: ConversationMessageDto;
  index: number;
  isLoading: boolean;
  messages: ConversationMessageDto[];
};

export function ChatMessage({ message, index, isLoading, messages }: ChatMessageProps) {
  const { isLoading: isLoadingContext } = useCustomerChatbotContext();

  if (isLoadingContext) return null;
  return (
    <div key={message.id} className={`relative ${message.role === 'assistant' ? '' : 'self-end'}`}>
      <div className="flex flex-col space-y-2">
        {message.role === 'user' ? (
          <UserMessage message={message} />
        ) : (
          // Prevents tool results messages to display a loading state when user sends a new message.
          <AiMessage message={message} isLoading={isLoading && messages.at(-1)?.id === message.id} />
        )}
        <MessageInfo isLoading={isLoading} message={message} index={index} messages={messages} />
      </div>
    </div>
  );
}

function MessageInfo({ isLoading, message, index, messages }: ChatMessageProps) {
  if (!message.createdAt || (isLoading && message.role === 'assistant' && messages.length - 1 === index)) return null;
  return (
    <span className={`text-xs text-textColor px-1 ${message.role === 'assistant' ? 'text-start' : 'text-end'}`}>
      {`${new Date(message.createdAt).toLocaleTimeString('es-AR', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      })}`}
    </span>
  );
}
